import type { TextFieldProps } from '@mui/material';
import { MenuItem, TextField, Typography } from '@mui/material';
import { isNotEmptyString, isNotNullOrUndefined, withDefault } from '@vy/utils';
import React from 'react';

type BaseSelectProps = TextFieldProps & {
  textFieldProps?: React.InputHTMLAttributes<HTMLInputElement>;
  values: string[] | number[];
  prefix?: string;
  suffix?: string;
  suffixByFieldValue?: Record<string, string>;
  withNone?: boolean;
  getLabelOption?: (option: string) => string;
  topLabel?: string;
};

export const BaseSelect = React.forwardRef<HTMLInputElement, BaseSelectProps>(
  (
    { values, label, prefix, suffix, suffixByFieldValue, withNone, getLabelOption, topLabel, ...props },
    ref,
  ) => {
    return (
      <>
        <Typography
          sx={{
            transform: 'unset',
            fontSize: '12px',
            position: 'unset',
            marginBottom: '8px',
            color: '#1B3D5599',
          }}
        >
          {label}
        </Typography>
        <TextField
          {...props}
          label={topLabel}
          defaultValue={props.defaultValue ?? props.placeholder ?? ''}
          sx={{
            '& .MuiSelect-select:focus': {
              backgroundColor: 'transparent',
            },
          }}
          ref={ref}
          select
        >
          {isNotNullOrUndefined(props.placeholder) && (
            <MenuItem value={props.placeholder}>{props.placeholder}</MenuItem>
          )}
          {withDefault(withNone, true) && (
            <MenuItem value="" placeholder="None">
              <em>None</em>
            </MenuItem>
          )}

          {values.map((Base) => (
            <MenuItem key={crypto.randomUUID()} value={Base}>
              <span className="flex gap-x-1">
                {isNotEmptyString(prefix) && <span>{prefix}</span>}
                <span>{isNotNullOrUndefined(getLabelOption) ? getLabelOption(Base.toString()) : Base}</span>
                {isNotEmptyString(suffix) && <span>{suffix}</span>}
                {isNotNullOrUndefined(suffixByFieldValue) && isNotEmptyString(suffixByFieldValue[Base]) && (
                  <span>{suffixByFieldValue[Base]}</span>
                )}
              </span>
            </MenuItem>
          ))}
        </TextField>
      </>
    );
  },
);
